

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {
        desde: this.currentdate()

      }

    };
  },

  computed: {
    reporte: function () {
      return '/reportes/ventas?dsis=' + window.sssdi + '&desde=' + this.f_c.desde

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': false,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

      'rowCallback': function (row, data, index) { },



    });
    $('.box').boxWidget();
    this.consultar()
  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();


      this.$http
        .post('/reportes/ventas', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            response.data.data.forEach(element => {
              this.ventast_tabla += parseFloat(element[1]);
              element[1] = this.num_to_many(element[1]);
              element[2] = this.num_to_many(element[2]);
              element[3] = this.num_to_many(element[3]);
              element[4] = this.num_to_many(element[4]);
              this.tbv.row.add(element);

            });

            this.ventast_tabla = this.num_to_many(this.ventast_tabla.toFixed(2));

            this.tbv.draw();

          }

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/pagos/tventas/tventas.js